import script from "./DataOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./DataOverview.vue?vue&type=script&setup=true&lang=js"

import "./DataOverview.vue?vue&type=style&index=0&id=770c7fba&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-770c7fba"]])

export default __exports__